<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {}
	}
</script>

<style>
	@import url('assets/css/global.css');
	body {
		margin: 0;
		background: #fff;
		font-family: Lato, Arial, sans-serif;
		font-style: normal;
		font-weight: 400;
		letter-spacing: .25px;
		font-size: 14px;
		line-height: 1.4286;
		color: #333;
		min-height: 100vh;
	}
	.body-container {
		overflow: overlay;
	}
	.modal-open {
	    overflow: inherit;
	    padding-right: inherit;
	}
</style>
